import React, { ReactElement, useContext } from 'react';
import logoSquareIcon from '@/assets/icons/front/logo-square.svg';
import HeaderMenu from './HeaderMenu';
import { HeaderContext } from '@/shared/contexts/Header';
import Button from '@/features/marketing/components/Button';
import Link from '@/shared/ui/Link';
import menuDefaults from '@/shared/data/MenuDefaults';
import HeaderHamburger from './HeaderHamburger';
import HeaderMobileMenu from './HeaderMobileMenu';
import Image from 'next/image';
import useUserContext from '@/shared/hooks/useUserContext';
import { isNull, isUndefined } from 'lodash';
import ActionButton from '@/shared/ui/ActionButton';

type Props = {};

const Header : React.FC<Props> = () : ReactElement => {
    const { dispatchMenuSection } = useContext(HeaderContext);
    const currentUser = useUserContext();

    return (
        <header className='sticky top-0 w-full z-[999] bg-white h-[calc(3rem+1px)] lg:h-[calc(5rem+1px)] drop-shadow-md lg:drop-shadow-none'>
            <div className='wrapper block xl:!mx-auto md:px-3 md:mx-auto xl:!px-14 2xl:px-20 h-[calc(3rem+1px)] lg:h-[calc(5rem+1px)]'>
                <nav className='flex flex-row justify-between items-center h-[calc(3rem+1px)] lg:h-[calc(5rem+1px)] w-full max-w-[1214px] 2xl:min-w-[1225px] 2xl:max-w-[1225px] mx-auto' role='navigation'>
                    <Link to='/'>
                        <Image
                            src={logoSquareIcon}
                            alt='BUBO trans Logo'
                            width='60'
                            height='50'
                            className='w-[36px] h-[30px] lg:w-[60px] lg:h-[50px]'
                        />
                    </Link>

                    <HeaderHamburger />

                    <div className='hidden lg:flex flex-row gap-5 2xl:gap-[40px]'>
                        {
                            menuDefaults.map((menuSection) => {
                                return (
                                    <Link
                                        key={menuSection.id}
                                        to={menuSection.path}
                                        className='text-[18px] text-[#14274D] leading-[24px] font-bold duration-200 hover:text-[#633998]'
                                        onMouseEnter={() => dispatchMenuSection(menuSection)}
                                    >
                                        {menuSection.name.translation.fallback}
                                    </Link>
                                );
                            })
                        }
                    </div>

                    <div className='hidden lg:flex flex-row gap-5 2xl:gap-5'>
                        {
                            (!isUndefined(currentUser?.id) && !isNull(currentUser?.id))
                                ? <>
                                    <Link to='/odhlasit'>
                                        <Button type='empty' className='!text-red-700 hover:!text-red-800'>Odhlásit</Button>
                                    </Link>
                                    <Link to='/app/spocitat-prepravu'>
                                        <ActionButton color='primary' variant='filled' size='small'>Přejít do systému</ActionButton>
                                    </Link>
                                </>
                                : <>
                                    <Link to='/prihlaseni'>
                                        <ActionButton color='primary' variant='filled' size='small'>Přihlásit</ActionButton>
                                    </Link>

                                    <Link to='/registrace'>
                                        <ActionButton color='secondary' size='small'>Vytvořit účet zdarma</ActionButton>
                                    </Link>
                                </>
                        }
                    </div>
                </nav>
            </div>

            <HeaderMenu />

            <HeaderMobileMenu />
        </header>
    );
};

export default Header;
